import { Button } from "primereact/button";
import React from "react";

export interface PrimaryButtonProps {
  label?: string;
  size?: string;
  className?: string;
  icon?: string | React.JSX.Element;
  onClick?: () => void;
  disabled?: boolean;
  iconPos?: "left" | "right";
  dataTestId?: string;
  type?: "button" | "reset" | "submit";
  loading?: boolean;
}

/** Customized Primary Button - solid filled */
export const PrimaryButton = ({
  label,
  size,
  className,
  onClick,
  icon,
  disabled = false,
  iconPos = "left",
  dataTestId,
  type = "button",
  loading = false,
}: PrimaryButtonProps) => {
  const isIconUndefinedOrString =
    icon === undefined || typeof icon === "string";

  return (
    <Button
      rounded
      onClick={onClick}
      label={isIconUndefinedOrString ? label : undefined}
      icon={typeof icon === "string" ? icon : undefined}
      iconPos={iconPos ?? "left"}
      size="small"
      className={`uppercase border-2 ${size ?? ""} font-bold primary-button ${className}`}
      disabled={disabled}
      data-testid={dataTestId}
      type={type}
      loading={loading}
    >
      {!isIconUndefinedOrString &&
        (iconPos === "left" ? (
          <>
            {React.isValidElement(icon) && icon}
            {label && <span className={"ml-1"}>{label}</span>}
          </>
        ) : (
          <>
            {label && <span className={"mr-1"}>{label}</span>}
            {React.isValidElement(icon) && icon}
          </>
        ))}
    </Button>
  );
};
